import { axiosApi } from "./helper";
import { store } from "../store/configureStore";
import * as accountActions from "../store/actions/accountActions";
import consola from "consola";

export function loginSSO(token) {
  return axiosApi("sso/connect", {}, "post", {
    "SSO-Token": token,
  }, {ispublic: true});
}

export function logSSO(reason) {
  return axiosApi("sso/log", { reason }, "get", {}, {ispublic: true})
}

// Création de compte
export function createAccountAPI(data) {
  delete data.hasCode;
  // delete data.code
  return axiosApi("account/create", data, "post", {}, {ispublic: true})
}

// Vérification de l'email pour la demande de nouveau mot de passe
export function forgotPassword(mail) {
  let obj = {
    mail: mail,
  };
  return axiosApi("connect/forget-password", obj, "post", {}, {ispublic: true})
}

// Nouveau mot de passe
export function NewPasswords(obj, token) {
  return axiosApi("account", obj, "put", { Authorization: `Bearer ${token}` });
}

export function changePassword(obj) {
  return axiosApi("new-password", obj, "post");
}

// Reset mot de passe
export function resetNewPassword(password, token) {
  let obj = {
    password: password,
    token: token,
  };
  return axiosApi("reset-password", obj, "post", {}, {ispublic: true})
}

export function autocomplete(obj) {
  return axiosApi("auto-suggest-store", obj, "get", {}, {ispublic: true})
}

export function refreshAccountData() {
  consola.info("Refreshing account data");
  return new Promise((resolve, reject) => {
    axiosApi("account", {}, "get").then(
      (data) => {
        consola.success("Account data refreshed")
        store.dispatch(accountActions.setAccountDatas(data));
        resolve(data);
      },
      (error) => {
        reject(error);
      }
    );
  });
}

export function sendAccount(obj) {
  return axiosApi("account", obj, "put");
}

export function getSponsorshipList(obj) {
  return axiosApi("sponsorships", obj, "get");
}

export function sendMail(obj) {
  return axiosApi("sponsorMail", obj, "post");
}

export function getUserPosts() {
  return axiosApi("user/posts", {}, "get");
}

/**
 * GET USER ORDERS
 */
export function getUserOrders(number_page, offset) {
  return axiosApi("orders/" + number_page + "/" + offset, {}, "get");
}

/**
 * GET USER ORDER
 */
export function getUserOrder(id) {
  return axiosApi("orders/" + id, {}, "get");
}

export function pointsHistory() {
  return axiosApi("profile/history", {}, "get");
}

export function allCourses(obj) {
  return axiosApi("courses/filtering", obj, "get");
}

export function allGroups() {
  return axiosApi("profile/usergroups", {}, "get");
}

export function groupVideos(groupId) {
  return axiosApi("videos/usergroup/" + groupId, {}, "get");
}

export function updateDeliveryAddress(address) {
  return axiosApi("account/deliveryAddress", address, "put");
}
